/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */
import { ThemeProvider } from '../../../../../themes';
import IconHelp from '../../../../../Icon/IconHelp';

export default {
  id: 'rtl',
  title: 'RTL',
  description:
    'Some icons will be [automatically mirrored](http://google.github.io/material-design-icons/#which-icons-should-be-mirrored-for-rtl-) for RTL (right-to-left) languages, depending on context.',
  scope: { IconHelp, ThemeProvider },
  source: `
    <ThemeProvider theme={{ direction: 'rtl' }}>
      <IconHelp />
    </ThemeProvider>`
};



// WEBPACK FOOTER //
// ./src/website/app/demos/Icon/examples/rtl.js